var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.isAuthByCode && !_vm.isRegisterOrLoginPage)?_c('AuthByCode'):(this.isLoggedIn && !this.isLogoutAction && !_vm.isRegisterOrLoginPage)?[_c('site-sidebar'),_c('site-header'),_c('site-content')]:(!this.isLogoutAction || _vm.isRegisterOrLoginPage)?_c('RouterContainer'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }